<template>
	<div>
		<el-dialog :close-on-click-modal="false" title="修改角色" :visible.sync="dialogVisible" width="30%"
			:before-close="handleClose">
			<div>
				<el-form :model="form" :rules="rules" ref="roleForm" label-width="100px">
					<el-form-item label="角色名稱" prop="role_name">
						<el-input v-model="form.role_name" placeholder="請輸入"></el-input>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input v-model="form.remark" placeholder="請輸入"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form:{
					id:"",
					role_name:"",
					remark:""
				},
				rules:{
					role_name:[{required:true,message:"角色名稱不能为空",trigger:"blur"}],
				}
			}
		},
		created() {

		},
		methods: {
			submit() {
				this.$refs.roleForm.validate((valid)=>{
					if(valid){
						this.$request({
							url:this.$api.role.update,
							method:"post",
							data:this.form
						}).then((res)=>{
							if(res.data.code==1){
								this.$message.success(res.data.msg);
								this.$emit("ok");
							}else{
								this.$message.error(res.data.msg);
							}
						}).catch(()=>{
							this.$message.error("请求失败")
						})
					}else{
						return false;
					}
				})

			},
			getData(val){
				this.form = {
					id:val.id,
					role_name:val.role_name,
					rule:val.rule,
					remark:val.remark
				}
			},
			handleClose() {
				this.$emit("close");
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/role/RoleEditModal.vue